import styled, {CSSObject} from 'styled-components';

interface CustomTextProps {
  customStyles?: CSSObject;
}

const CustomText = styled.div<CustomTextProps>`
  font-family: var(--font-family-text, vw-text);
  ${(props) => props.customStyles};
`;

export default CustomText;
